import { Modal } from '@/components/common/AppModal';
import FalconCloseButton from '@/components/common/FalconCloseButton';
import { FiInfo as Info } from 'react-icons/fi';
import { mentoringConfig, ui } from '../constants';

interface MentoringVideoModalProps {
  show: boolean;
  onClose: () => void;
  videoFailed: boolean;
  onVideoError: () => void;
}

function MentoringVideoModal({
  show,
  onClose,
  videoFailed,
  onVideoError,
}: MentoringVideoModalProps) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      centered
      className="pricing-mentoring-video-modal"
      dialogClassName="pricing-mentoring-video-modal-dialog"
      contentClassName="pricing-mentoring-video-modal-content"
    >
      <Modal.Header className="pricing-mentoring-video-modal-header border-0 pb-0">
        <div className="flex-grow-1">
          <span className="eyebrow mentoring-eyebrow fs--2">
            {mentoringConfig.video.modalEyebrow}
          </span>
          <Modal.Title as="h2" className="pricing-mentoring-video-modal-title">
            {mentoringConfig.video.modalTitle}
          </Modal.Title>
        </div>
        <FalconCloseButton
          onClick={onClose}
          aria-label={ui.common.closeVideo}
          className="pricing-mentoring-video-modal-close"
        />
      </Modal.Header>

      <Modal.Body className="pricing-mentoring-video-modal-body">
        <div className="mentoring-video-modal-player">
          {!videoFailed ? (
            <video
              key={mentoringConfig.video.url}
              autoPlay
              controls
              playsInline
              preload="auto"
              poster={mentoringConfig.video.poster}
              src={mentoringConfig.video.url}
              onError={onVideoError}
            />
          ) : (
            <div className="video-fallback">
              <img src={mentoringConfig.video.poster} alt={mentoringConfig.video.label} />
              <div>
                <Info size={22} />
                <strong>{mentoringConfig.video.fallbackTitle}</strong>
                <span className="fs--2">{mentoringConfig.video.fallbackText}</span>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default MentoringVideoModal;
